// client/src/pages/tabs/Edgemarc-tab/Edgemarc.jsx
import React from 'react';
import { useParams } from 'react-router-dom';

import useEdgemarc from './useEdgemarc';
import SshSection from './components/SshSection';
import WhoisSection from './components/WhoisSection';
import TcpDumpSection from './components/TcpDumpSection';

function Edgemarc({ tabColors = { bgcolor: 'bg-red-300', nocolor: 'bg-red-100', hovercolor: 'hover:bg-red-200' } }) {
  const { id } = useParams();
  const {
    formData,
    inputs,
    handleInputChange,
    copyToClipboard,
    lanIpEnabled,
    toggleLanIp,
  } = useEdgemarc(id);

  return (
    <div className='min-h-screen p-4'>
      <div className="max-w-7xl mx-auto space-y-4">
        {/* First Row - Fixed width sections side by side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex-1 min-w-0"> {/* Constrained width for WHOIS */}
            <WhoisSection 
              wan1Command={inputs.inputWhoIsWan1.value}
              wan2Command={inputs.inputWhoIsWan2.value}
              copyToClipboard={copyToClipboard}
            />
          </div>
          <div className="flex-1 min-w-0"> {/* Constrained width for TCPDUMP */}
            <TcpDumpSection
              formData={formData}
              inputs={inputs}
              handleInputChange={handleInputChange}
              copyToClipboard={copyToClipboard}
              lanIpEnabled={lanIpEnabled}
              toggleLanIp={toggleLanIp}
            />
          </div>
        </div>

        {/* Second Row - Full width SSH section */}
        <div>
          <SshSection 
            wan1Command={inputs.inputSecureCrtWan1.value}
            wan2Command={inputs.inputSecureCrtWan2.value}
            copyToClipboard={copyToClipboard}
          />
        </div>
      </div>
    </div>
  );
}

export default Edgemarc;